import {useDispatch, useSelector} from "react-redux";
import {SORT_LIST_PRODUCT} from "../../utils/sort-list";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useEffect} from "react";
import {setToolsInitialState} from "../../reducers/tools.reducer";
import {useEffectAfterMount} from "../../services/useEffectAfterMount";
import {setBeautyEmptiesProductSelectedRowKeys} from "../../reducers/beauty-empties.reducer";
import BeautyEmptiesProductList from "./beauty-empties-product-list";
import BeautyEmptiesProductFilter from "./beauty-empties-product-filter";

const BeautyEmptiesProduct = () => {
    const dispatch = useDispatch()
    const defaultSort = SORT_LIST_PRODUCT.find(item => item.isDefault)
    const getOrderBy = defaultSort?.key.split('_')
    const {
        currentPage,
        pageSize,
        orderBy,
        sort,
        searchKey,
        filter,
        reload
    } = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
        orderBy: !!orderBy ? orderBy : getOrderBy[0],
        orderType: sort,
        search: searchKey,
        filterByCategory: filter['category'] ?? [],
        filterByStatus: filter['status'] ?? []
    }
    const {
        data: response,
        fetching: getProductList,
        isLoading
    } = useFetch(API.BEAUTY_EMPTIES_PRODUCT_LIST, queryParams, {isWithTotalData: true})

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
            dispatch(setBeautyEmptiesProductSelectedRowKeys([]))
        }
    }, [])

    useEffectAfterMount(() => {
        getProductList()
    }, [currentPage, pageSize, orderBy, sort, searchKey, filter, reload])

    return (
        <div className={"col px-10"}>
            <BeautyEmptiesProductFilter/>
            <BeautyEmptiesProductList datasource={response?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default BeautyEmptiesProduct
